// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ({"810":"common/utils/lottie-web/build/player/lottie_light_canvas","855":"forum/components/StickerPicker"}[chunkId] + ".js");